module.exports = __webpack_public_path__ + "static/img/A-TFapple.04db78a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/A-TFapple.png
// module id = kQuw
// module chunks = 3